import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface ComparisonImage {
  id: string;
  title: string;
  fileName: string;
  contentType: string;
  payload: string;
  createdAt: Date;
}

@Component({
  selector: 'app-compare-images-modal',
  templateUrl: './compare-images-modal.component.html',
  styleUrls: ['./compare-images-modal.component.scss']
})
export class CompareImagesModalComponent implements OnInit {
  @Input() images: ComparisonImage[] = [];
  @Input() patientId: string;
  @Output() closeEmitter = new EventEmitter<void>();

  public globalZoom = 1;
  public individualZooms: number[] = [];
  public syncZoom = true;
  public gridColumns = 2;

  ngOnInit(): void {
    // Initialiser les zooms individuels
    this.individualZooms = this.images.map(() => 1);
    
    // Déterminer la grille (2 colonnes pour 2 images, 2x2 pour 3-4 images)
    this.gridColumns = this.images.length === 2 ? 2 : 2;
  }

  // Zoom global
  public setGlobalZoom(delta: number): void {
    this.globalZoom = Math.max(0.5, Math.min(3, this.globalZoom + delta));
    if (this.syncZoom) {
      this.individualZooms = this.individualZooms.map(() => this.globalZoom);
    }
  }

  // Zoom individuel
  public setIndividualZoom(index: number, delta: number): void {
    if (!this.syncZoom) {
      this.individualZooms[index] = Math.max(
        0.5, 
        Math.min(3, this.individualZooms[index] + delta)
      );
    }
  }

  public resetZoom(): void {
    this.globalZoom = 1;
    this.individualZooms = this.images.map(() => 1);
  }


  public close(): void {
    this.closeEmitter.emit();
  }

  // Helper pour obtenir l'URL de l'image
  public getImageUrl(image: ComparisonImage): string {
    return `data:${image.contentType};base64,${image.payload}`;
  }
}
